import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

const ElementTable = ({ data = [] }) => {
  const { t } = useTranslation("global");

  const columns = [
    { id: 'Elemento', label: t('generator.limits.table.element'), minWidth: 170 },
    { id: 'Codigo', label: t('generator.limits.table.code'), minWidth: 100 },
    { id: 'Coincidencia', label: t('generator.limits.table.coincidence'), minWidth: 170 },
    ...Array.from({ length: 24 }, (_, i) => ({ 
      id: `P${i.toString().padStart(2, '0')}`, 
      label: `P${i.toString().padStart(2, '0')}`, 
      minWidth: 50 
    }))
  ];

  const getTransformedRows = () => {
    if (!Array.isArray(data)) {
      console.error('Los datos proporcionados no son un array:', data);
      return [];
    }

    return data.map(item => {
      if (!item || typeof item !== 'object') {
        console.error('Ítem de datos inválido:', item);
        return { Elemento: 'Dato inválido' };
      }

      const pFields = item.P || {};
      const pEntries = pFields instanceof Map ? 
        Array.from(pFields.entries()) : 
        Object.entries(pFields);

      const pObject = Object.fromEntries(pEntries);

      return {
        Elemento: item.Elemento || '',
        Codigo: item.Codigo || '',
        Coincidencia: item.Coincidencia || '',
        ...pObject
      };
    });
  };

  const transformedRows = getTransformedRows();

  if (transformedRows.length === 0) {
    return (
      <Paper
        sx={{ 
          width: '100%', 
          padding: '20px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          border: '1px solid #551a8b', 
          borderRadius: '20px', 
          boxShadow: '7px 7px 20px rgba(0, 0, 0, 0.5)', 
          marginBottom: '50px' 
        }}
      >
        <Typography variant="h6" color="textSecondary">
          {t('generator.limits.table.noData')}
        </Typography>
      </Paper>
    );
  }

  return (
    <Paper
      sx={{ width: '100%', overflow: 'hidden' }}
      style={{ 
        border: '1px solid #551a8b', 
        borderRadius: '20px', 
        padding: '20px 5px 10px 10px', 
        boxShadow: '7px 7px 20px rgba(0, 0, 0, 0.5)', 
        marginBottom: '50px' 
      }}
    >
      <TableContainer sx={{
        maxHeight: 440,
        maxWidth: '99%',
        '&::-webkit-scrollbar': {
          width: '10px',
          height: '10px',
        },
        '&::-webkit-scrollbar-track': {
          backgroundColor: '#f1f1f1',
          borderRadius: '4px',
        },
        '&::-webkit-scrollbar-thumb': {
          backgroundColor: '#551a8b',
          borderRadius: '4px',
        },
        '&::-webkit-scrollbar-thumb:hover': {
          backgroundColor: '#3e1163',
        },
        scrollbarColor: '#551a8b #f1f1f1',
        scrollbarWidth: 'thin',
      }}>
        <Table stickyHeader aria-label='sticky table'>
          <TableHead>
            <TableRow hover>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  style={{ 
                    minWidth: column.minWidth, 
                    backgroundColor: '#551a8b', 
                    color: 'white', 
                    padding: '0 16px' 
                  }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {transformedRows.map((row, index) => (
              <TableRow hover role='checkbox' tabIndex={-1} key={`row-${index}`}>
                {columns.map((column) => (
                  <TableCell 
                    key={`${column.id}-${index}`} 
                    align={column.align}
                  >
                    {row[column.id] ?? ''}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
}

export default ElementTable;